export const parsePermissions = config => (
  {
    permissions: config.permissions || [],
    subscriptionLabel: config.subscriptionLabel || 'free'
  }
)
